import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';

import CH from './assets/lang/CH.json'
import EN from "./assets/lang/EN.json";
import plugins from "./assets/plugins.js";
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(plugins)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
